import { Container } from 'reactstrap';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import CountriesList from '../../../Component/Application/Countries/CountriesList';
import { useTranslation } from 'react-i18next';

const CountriesManagement = () => {
  const { t } = useTranslation();
  return (
    <div className="page-body">
      <Breadcrumbs mainTitle={t('Gestión de Países')} parent={t('Administración')} />
      <Container fluid>
        <CountriesList />
      </Container>
    </div>
  );
};

export default CountriesManagement;

